<template>
  <div class="header dashboard">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <nav class="navbar navbar-expand-lg navbar-light px-0">
            <router-link class="navbar-brand" to="/"
              ><img src="../../assets/images/w_logo.png" alt=""
            /></router-link>
            <b-navbar-toggle target="navbarSupportedContent"> </b-navbar-toggle>

            <b-collapse as="div" id="navbarSupportedContent" is-nav>
              <ul class="navbar-nav">
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/"
                    :class="active === 1 && 'active'"
                    >Dashboard</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="buy-sell"
                    :class="active === 2 && 'active'"
                    >Buy/Sell</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="accounts"
                    :class="active === 3 && 'active'"
                    >Accounts</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="settings"
                    :class="active === 4 && 'active'"
                    >Settings</router-link
                  >
                </li>
              </ul>
            </b-collapse>
            <div class="dashboard_log my-2">
              <div class="d-flex align-items-center">
                <div class="account_money">
                  <ul>
                    <li class="crypto">
                      <span>0.0025</span>
                      <i class="cc BTC-alt"></i>
                    </li>
                    <li class="usd">
                      <span>19.93 USD</span>
                    </li>
                  </ul>
                </div>
                <b-nav-item-dropdown
                  right
                  menu-class="dropdown-menu"
                  toggle-class="p-0 i-false"
                  tag="div"
                  class="profile_log"
                >
                  <template #button-content>
                    <div class="user">
                      <span class="thumb"><i class="la la-user"></i></span>
                      <span class="name">Maria Pascle</span>
                      <span class="arrow"
                        ><i class="la la-angle-down"></i
                      ></span>
                    </div>
                  </template>
                  <router-link to="accounts" class="dropdown-item">
                    <i class="la la-user"></i> Account
                  </router-link>
                  <router-link to="history" class="dropdown-item">
                    <i class="la la-book"></i> History
                  </router-link>
                  <router-link to="settings" class="dropdown-item">
                    <i class="la la-cog"></i> Setting
                  </router-link>
                  <router-link to="lock" class="dropdown-item">
                    <i class="la la-lock"></i> Lock
                  </router-link>
                  <router-link to="/signin" class="dropdown-item logout">
                    <i class="la la-sign-out"></i> Logout
                  </router-link>
                </b-nav-item-dropdown>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  props: {
    active: Number,
  },
};
</script>
